'use client';
import React, { useEffect, useRef, useState } from "react";
import { Sidebar, SidebarBody, SidebarLink, SidebarLinkNoHref } from "@/components/aceternity/sidebar";
import { Command } from 'cmdk' 
import {
  IconArrowLeft,
  IconBrandTabler,
  IconSettings,
  IconUserBolt,
  IconArrowNarrowLeft,
  IconArrowNarrowRight,
  IconX,
  IconArrowRight,
  IconLayoutNavbarCollapse,
  IconMenu2, 
  IconArrowWaveRightUp,
  IconBoxAlignRightFilled,
  IconBoxAlignTopLeft,
  IconClipboardCopy,
  IconFileBroken,
  IconSignature,
  IconTableColumn,
  IconBrandYoutubeFilled,
  IconAdjustmentsBolt,
  IconCloud,
  IconCurrencyDollar,
  IconEaseInOut,
  IconHeart,
  IconHelp,
  IconRouteAltLeft,
  IconTerminal2,
  IconBrandGithub,
  IconBrandX,
  IconExchange,
  IconHome,
  IconNewSection,
  IconBellRinging2,
  IconPrompt,
  IconSquareArrowRight,
} from "@tabler/icons-react";
import Link from "next/link";
import { motion } from "framer-motion";
import Image from "next/image";
import { cn } from "@/lib/utils";


import {
  Collapsible,
  CollapsibleContent,
  CollapsibleTrigger,
} from "@/components/ui/collapsible";
import { ChevronDown, ChevronRight, CombineIcon, Music2Icon, PictureInPicture2, Search } from "lucide-react";


import type { User } from 'next-auth';
import { usePathname, useRouter } from 'next/navigation';

import { PlusIcon } from '@/components/icons';
import { SidebarHistory } from '@/components/sidebar-history';
import { SidebarUserNav } from '@/components/sidebar-user-nav_new';
import { Button } from '@/components/ui/button';
import {
  Sidebar as ASideBar,
  SidebarContent,
  SidebarFooter,
  SidebarHeader,
  SidebarMenu,
  useSidebar,
} from '@/components/ui/sidebar';
// import Link from 'next/link';
// import { Tooltip, TooltipContent, TooltipTrigger } from './ui/tooltip';
import { CMDKWrapper, Item } from  "@/components/ui/raycast";
import { useWindowSize } from "usehooks-ts";
import useGlobalStore from "@/stores/global-store";
import { useDebouncedCallback } from "use-debounce";
import { Comic_Neue } from "next/font/google";
import { DOCS } from "./left-data/documentation.constant";


export type NavLink = {
  title: string;
  label: string;
  href: string;
  icon?: React.JSX.Element;
}

export const navLinkNull:NavLink = {
  title: '',
  label: '',
  href: '',
}

export const DefaultNavLink:NavLink = {
  title: "导航", label: "通用任务", href: "#work", icon: (<IconHome className="text-neutral-700 dark:text-neutral-200 h-5 w-5 shrink-0" />),
}

// 自动问答：auto
// 引导式对话：guided
// 沉浸式写作：writing
// 任务编排：task
// 智识源地：intellect
// 简短文案工具箱：brief
// 中长篇小说工作流：novel
// 影视编导：film
// 媒体文案：media
// 提示词生成：prompten
// 测评与决策指导建议：eval

export const navlinks = [
  { title: "导航", label: "通用任务", href: "#work", icon: (<IconHome className="text-neutral-700 dark:text-neutral-200 h-5 w-5 shrink-0" />)},
  // { title: "导航", label: "通用功能", href: "#guidance", icon: (<IconAdjustmentsBolt className="text-neutral-700 dark:text-neutral-200 h-5 w-5 shrink-0" />)},
  // { title: "导航", label: "历史会话", href: "#history", icon: (<IconMenu2 className="text-neutral-700 dark:text-neutral-200 h-5 w-5 shrink-0" />)},

  // { title: "Lecture", label: "智识源地", href: "/intellect", icon: (<IconClipboardCopy className="text-neutral-700 dark:text-neutral-200 h-5 w-5 shrink-0" />)},

  // { title: "Writing", label: "引导式协作", href: "/guided", icon: (<IconAdjustmentsBolt className="text-neutral-700 dark:text-neutral-200 h-5 w-5 shrink-0" />)},
  // { title: "History", label: "自动化生成", href: "/auto", icon: (<IconLayoutNavbarCollapse className="text-neutral-700 dark:text-neutral-200 h-5 w-5 shrink-0" />)},
  // { title: "Writing", label: "沉浸式写作", href: "/writing", icon: (<IconSignature className="text-neutral-700 dark:text-neutral-200 h-5 w-5 shrink-0" />)},
  // { title: "task", label: "任务编排", href: "/task", icon: (<IconEaseInOut className="text-neutral-700 dark:text-neutral-200 h-5 w-5 shrink-0" />)},
  // { title: "Lecture", label: "智识源地", href: "/lecture", icon: (<IconClipboardCopy className="text-neutral-700 dark:text-neutral-200 h-5 w-5 shrink-0" />)},

  // { title: "Dev", label: "Dev", href: "/dev", icon: (<IconExchange className="text-neutral-700 dark:text-neutral-200 h-5 w-5 shrink-0" />)},
  // { title: "Writing", label: "自由对话", href: "/writing", icon: (<IconNewSection className="text-neutral-700 dark:text-neutral-200 h-5 w-5 shrink-0" />)},
  // { title: "Dashboard", label: "Dashboard", href: "/dashboard", icon: (<IconArrowWaveRightUp className="text-neutral-700 dark:text-neutral-200 h-5 w-5 shrink-0" />)},
  // { title: "Writing", label: "自动问答", href: "/writing", icon: (<IconLayoutNavbarCollapse className="text-neutral-700 dark:text-neutral-200 h-5 w-5 shrink-0" />)},
  // { title: "Writing", label: "教案助手", href: "/writing", icon: (<IconSignature className="text-neutral-700 dark:text-neutral-200 h-5 w-5 shrink-0" />)},
  // { title: "Template", label: "AI 模版专区", href: "/template", icon: (<IconAdjustmentsBolt className="text-neutral-700 dark:text-neutral-200 h-5 w-5 shrink-0" />)},
  // { title: "Links", label: "AI 网址导航", href: "/links", icon: (<IconTableColumn className="text-neutral-700 dark:text-neutral-200 h-5 w-5 shrink-0" />)},
  // { title: "Column", label: "仪表盘", href: "/dashboard", icon: (<IconMenu2 className="text-neutral-700 dark:text-neutral-200 h-5 w-5 shrink-0" />)},
];


const testlinks = [
  { title: "Eval", label: "测评与建议", href: "#eval", icon: (<IconHeart className="text-neutral-700 dark:text-neutral-200 h-5 w-5 shrink-0" />)},
  // { title: "创作专区", label: "自媒体工具链", href: "#media", icon: (<IconCloud className="text-neutral-700 dark:text-neutral-200 h-5 w-5 shrink-0" />)},
  // { title: "Help", label: "使用帮助", href: "/prompten", icon: (<IconHelp className="text-neutral-700 dark:text-neutral-200 h-5 w-5 shrink-0" />)},
  // { title: "Cloud", label: "办公文案助手", href: "/doc", icon: (<IconCloud className="text-neutral-700 dark:text-neutral-200 h-5 w-5 shrink-0" />)},
  // { title: "AltLeft", label: "办公助手", href: "/work", icon: (<IconRouteAltLeft className="text-neutral-700 dark:text-neutral-200 h-5 w-5 shrink-0" />)},
  // { title: "UserBolt", label: "职场辅导", href: "/job", icon: (<IconUserBolt className="text-neutral-700 dark:text-neutral-200 h-5 w-5 shrink-0" />)},
  // { title: "ArrowNarrowLeft", label: "ArrowNarrowLeft", href: "/fileBroken", icon: (<IconArrowNarrowLeft className="text-neutral-700 dark:text-neutral-200 h-5 w-5 shrink-0" />)},
  // { title: "Terminal2", label: "AI 指令精选", href: "/command", icon: (<IconTerminal2 className="text-neutral-700 dark:text-neutral-200 h-5 w-5 shrink-0" />)},
  // { title: "History", label: "AI 对话列表", href: "#history", icon: (<IconLayoutNavbarCollapse className="text-neutral-700 dark:text-neutral-200 h-5 w-5 shrink-0" />)},
  // { title: "NewSection", label: "AI 图片生成", href: "/pict", icon: (<IconNewSection className="text-neutral-700 dark:text-neutral-200 h-5 w-5 shrink-0" />)},
  // { title: "NewSection", label: "AI 影视创作", href: "/movie", icon: (<IconNewSection className="text-neutral-700 dark:text-neutral-200 h-5 w-5 shrink-0" />)},
  // { title: "NewSection", label: "AI 音乐坊", href: "/movie", icon: (<IconNewSection className="text-neutral-700 dark:text-neutral-200 h-5 w-5 shrink-0" />)},
  // { title: "NewSection", label: "AI 漫画工场", href: "/movie", icon: (<IconNewSection className="text-neutral-700 dark:text-neutral-200 h-5 w-5 shrink-0" />)},

  // { title: "IconX", label: "IconX", href: "/main", icon: (<IconX className="text-neutral-700 dark:text-neutral-200 h-5 w-5 shrink-0" />)},
  // { title: "ArrowNarrowRight", label: "ArrowNarrowRight", href: "/dev", icon: (<IconArrowNarrowRight className="text-neutral-700 dark:text-neutral-200 h-5 w-5 shrink-0" />)},
  // { title: "Dashboard", label: "Dashboard", href: "/dashboard", icon: (<IconArrowRight className="text-neutral-700 dark:text-neutral-200 h-5 w-5 shrink-0" />)},
  // { title: "Dashboard", label: "Dashboard", href: "/dashboard", icon: (<IconArrowWaveRightUp className="text-neutral-700 dark:text-neutral-200 h-5 w-5 shrink-0" />)},
  // { title: "RightFilled", label: "RightFilled", href: "/dashboard", icon: (<IconBoxAlignRightFilled className="text-neutral-700 dark:text-neutral-200 h-5 w-5 shrink-0" />)},
  // { title: "TopLeft", label: "TopLeft", href: "/dashboard", icon: (<IconBoxAlignTopLeft className="text-neutral-700 dark:text-neutral-200 h-5 w-5 shrink-0" />)},
  // { title: "Youtube", label: "Youtube", href: "/dashboard", icon: (<IconBrandYoutubeFilled className="text-neutral-700 dark:text-neutral-200 h-5 w-5 shrink-0" />)},
  // { title: "Dollar", label: "Dollar", href: "/dashboard", icon: (<IconCurrencyDollar className="text-neutral-700 dark:text-neutral-200 h-5 w-5 shrink-0" />)},
  // { title: "Github", label: "Github", href: "/dashboard", icon: (<IconBrandGithub className="text-neutral-700 dark:text-neutral-200 h-5 w-5 shrink-0" />)},
  // { title: "BrandX", label: "BrandX", href: "/dashboard", icon: (<IconBrandX className="text-neutral-700 dark:text-neutral-200 h-5 w-5 shrink-0" />)},
];


export const medialinks = [
  { title: "自媒体工具链", label: "公众号", href: "#gongzhonghao", icon: (<IconBrandX className="text-neutral-700 dark:text-neutral-200 h-5 w-5 shrink-0" />)},
  // { title: "自媒体工具链", label: "短视频", href: "#duanshiping", icon: (<IconBrandYoutubeFilled className="text-neutral-700 dark:text-neutral-200 h-5 w-5 shrink-0" />)},
  { title: "自媒体工具链", label: "头条微博", href: "#toutiao", icon: (<IconSquareArrowRight className="text-neutral-700 dark:text-neutral-200 h-5 w-5 shrink-0" />)},
  { title: "自媒体工具链", label: "小红书", href: "#xiaohongshu", icon: (<IconCurrencyDollar className="text-neutral-700 dark:text-neutral-200 h-5 w-5 shrink-0" />)},
  // { title: "自媒体工具链", label: "社群运营", href: "#siyu", icon: (<IconNewSection className="text-neutral-700 dark:text-neutral-200 h-5 w-5 shrink-0" />)},
]

export const toollinks = [
  // { title: "创作专区", label: "提示词生成器", href: "#prompten", icon: (<IconPrompt className="text-neutral-700 dark:text-neutral-200 h-5 w-5 shrink-0" />)},
  { title: "创作专区", label: "短篇文案工具", href: "#brief", icon: (<IconFileBroken className="text-neutral-700 dark:text-neutral-200 h-5 w-5 shrink-0" />)},
  { title: "创作专区", label: "中长篇工作流", href: "#novel", icon: (<IconArrowWaveRightUp className="text-neutral-700 dark:text-neutral-200 h-5 w-5 shrink-0" />)},
  // { title: "创作专区", label: "影视编导工坊", href: "#film", icon: (<IconTableColumn className="text-neutral-700 dark:text-neutral-200 h-5 w-5 shrink-0" />)},

  // { title: "创作专区", label: "漫画图集工坊", href: "#film", icon: (<PictureInPicture2 className="text-neutral-700 dark:text-neutral-200 h-5 w-5 shrink-0" />)},
  // { title: "创作专区", label: "歌词字幕工坊", href: "#film", icon: (<Music2Icon className="text-neutral-700 dark:text-neutral-200 h-5 w-5 shrink-0" />)},
];

const edulinks = [
  { title: "教学专区", label: "教案助手", href: "#brief", icon: (<IconFileBroken className="text-neutral-700 dark:text-neutral-200 h-5 w-5 shrink-0" />)},
  { title: "教学专区", label: "课程助手", href: "#novel", icon: (<IconArrowWaveRightUp className="text-neutral-700 dark:text-neutral-200 h-5 w-5 shrink-0" />)},
  { title: "教学专区", label: "知识整理", href: "#film", icon: (<IconTableColumn className="text-neutral-700 dark:text-neutral-200 h-5 w-5 shrink-0" />)},
  { title: "教学专区", label: "学习计划", href: "#prompten", icon: (<IconHelp className="text-neutral-700 dark:text-neutral-200 h-5 w-5 shrink-0" />)},
]

const worklinks = [
  { title: "办公提效", label: "公文写作", href: "#brief", icon: (<IconFileBroken className="text-neutral-700 dark:text-neutral-200 h-5 w-5 shrink-0" />)},
  { title: "办公提效", label: "邮件写作", href: "#novel", icon: (<IconArrowWaveRightUp className="text-neutral-700 dark:text-neutral-200 h-5 w-5 shrink-0" />)},
  { title: "办公提效", label: "假条生成", href: "#film", icon: (<IconTableColumn className="text-neutral-700 dark:text-neutral-200 h-5 w-5 shrink-0" />)},
  { title: "办公提效", label: "提示词生成", href: "#prompten", icon: (<IconHelp className="text-neutral-700 dark:text-neutral-200 h-5 w-5 shrink-0" />)},
]

// const comiclinks = [
//   { title: "漫画工坊", label: "短篇文案工具", href: "#brief", icon: (<IconFileBroken className="text-neutral-700 dark:text-neutral-200 h-5 w-5 shrink-0" />)},
//   { title: "漫画工坊", label: "中长篇工作流", href: "#novel", icon: (<IconArrowWaveRightUp className="text-neutral-700 dark:text-neutral-200 h-5 w-5 shrink-0" />)},
//   { title: "漫画工坊", label: "影视编导工坊", href: "#film", icon: (<IconTableColumn className="text-neutral-700 dark:text-neutral-200 h-5 w-5 shrink-0" />)},
//   { title: "漫画工坊", label: "提示词生成", href: "#prompten", icon: (<IconHelp className="text-neutral-700 dark:text-neutral-200 h-5 w-5 shrink-0" />)},
// ]

// const musiclinks = [
//   { title: "音乐工坊", label: "短篇文案工具", href: "#brief", icon: (<IconFileBroken className="text-neutral-700 dark:text-neutral-200 h-5 w-5 shrink-0" />)},
//   { title: "音乐工坊", label: "中长篇工作流", href: "#novel", icon: (<IconArrowWaveRightUp className="text-neutral-700 dark:text-neutral-200 h-5 w-5 shrink-0" />)},
//   { title: "音乐工坊", label: "影视编导工坊", href: "#film", icon: (<IconTableColumn className="text-neutral-700 dark:text-neutral-200 h-5 w-5 shrink-0" />)},
//   { title: "音乐工坊", label: "提示词生成", href: "#prompten", icon: (<IconHelp className="text-neutral-700 dark:text-neutral-200 h-5 w-5 shrink-0" />)},
// ]

// const gamelinks = [
//   { title: "益智游戏", label: "短篇文案工具", href: "#brief", icon: (<IconFileBroken className="text-neutral-700 dark:text-neutral-200 h-5 w-5 shrink-0" />)},
//   { title: "益智游戏", label: "中长篇工作流", href: "#novel", icon: (<IconArrowWaveRightUp className="text-neutral-700 dark:text-neutral-200 h-5 w-5 shrink-0" />)},
//   { title: "益智游戏", label: "影视编导工坊", href: "#film", icon: (<IconTableColumn className="text-neutral-700 dark:text-neutral-200 h-5 w-5 shrink-0" />)},
//   { title: "益智游戏", label: "提示词生成", href: "#prompten", icon: (<IconHelp className="text-neutral-700 dark:text-neutral-200 h-5 w-5 shrink-0" />)},
// ]

const settingslinks = [
  {
    title: "Profile",
    label: "Profile",
    href: "/profile",
    icon: (
      <IconUserBolt className="text-neutral-700 dark:text-neutral-200 h-5 w-5 shrink-0" />
    ),
  },
  {
    title: "Settings",
    label: "Settings",
    href: "#",
    icon: (
      <IconSettings className="text-neutral-700 dark:text-neutral-200 h-5 w-5 shrink-0" />
    ),
  },
  {
    title: "Logout",
    label: "Logout",
    href: "#",
    icon: (
      <IconArrowLeft className="text-neutral-700 dark:text-neutral-200 h-5 w-5 shrink-0" />
    ),
  },
];














// export function DashSidebar() {
export function MainSidebar({ user }: { user: User | undefined }) {
  // const router = useRouter();
  // const { setOpenMobile } = useSidebar();
  const { spaceTag, setSpaceTag } = useSidebar();
  const { llog, setSelectedPath, setMouseOverPath } = useGlobalStore();

  // const { width: windowWidth, height: windowHeight } = useWindowSize();
  // const isMobile = windowWidth ? windowWidth < 768 : false;


  // 仅在开发环境暴露 store 到 window
  // if (process.env.NODE_ENV === 'development') {
  //   // 确保 store 已初始化
  //   const store = useGlobalStore;
  //   (window as any).zustandStore = store;
    
  //   // 可选：添加类型提示
  //   console.log('[DEV] Zustand Store 已挂载到 window.zustandStore');
  // }

  const [open, setOpen] = useState(false);
  const [animate, setAnimate] = useState(false);

  const [value, setValue] = useState('linear')
  const inputRef = useRef<HTMLInputElement | null>(null)
  const listRef = useRef(null)

  const pathname = usePathname();
  const [searchTerm, setSearchTerm] = useState("");
  const [openGroups, setOpenGroups] = useState<string[]>(
    DOCS.map((group) => group.phaseKey)
  );


    useEffect(() => {
      // llog('limk.log left sidebar pathname:' + pathname);
      // Ensure the group of the active link is open
      const activeGroup = DOCS.find((group) =>
        group.phaseTasks.some((child) => child.url === pathname)
      );
      if (activeGroup && !openGroups.includes(activeGroup.phaseKey)) {
        setOpenGroups((prev) => [...prev, activeGroup.phaseKey]);
      }
    }, [pathname]);
  
    const toggleGroup = (phaseKey: string) => {
      setOpenGroups((prev) =>
        prev.includes(phaseKey)
          ? prev.filter((key) => key !== phaseKey)
          : [...prev, phaseKey]
      );
    };
  
    const filteredDocs = DOCS.map((group) => ({
      ...group,
      children: group.phaseTasks
        .filter((child) =>
          child.label.toLowerCase().includes(searchTerm.toLowerCase())
        )
        .sort((a, b) => a.label.localeCompare(b.label)),
    })).filter((group) => group.phaseTasks.length > 0);

  const debouncedMoauseOver = useDebouncedCallback(async (value: string) => {
    // llog(`side bar useDebouncedCallback:${value}`);
    setMouseOverPath(value);
    setOpen(false);
    setAnimate(true);
  }, 300);
  const debounceSelect = useDebouncedCallback(async (value: string) => {
    console.log(`side bar useDebouncedCallback:${value}`);
    setSelectedPath(value)
    setOpen(false);
    ;
  }, 300);

  
  return (
    <Sidebar animate={animate} open={open} setOpen={setOpen} >
      <SidebarBody className="flex flex-col h-full  
       bg-gradient-to-r from-pink-100/20 to-purple-200/20
      ">
        <div className="flex flex-col h-full">
          {/* 顶部吸顶区域, 可滚动 */}
          <div className="shrink-0 sticky top-0 z-0 bg-inherit">
            {open ? <Logo /> : <LogoIcon />}
          </div>
           <div className="flex-1 overflow-y-auto">
            <CMDKWrapper key="raycast">
            <Command value={value} onValueChange={(v) => setValue(v)}>
              <div cmdk-raycast-top-shine="" />
              {/* <Command.Input  
                //   className="flex h-10 w-full rounded-md border border-input bg-background px-3 py-2 text-base ring-offset-background file:border-0 file:bg-transparent file:text-sm file:font-medium file:text-foreground placeholder:text-muted-foreground focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:cursor-not-allowed disabled:opacity-50 md:text-sm"
                className="h-9 w-full rounded-lg border border-zinc-950/10 bg-transparent p-2  placeholder-zinc-500 focus:outline-none"
                //   className="rounded-lg border border-neutral-800 focus:ring-2 focus:ring-teal-500  w-full relative z-10 mt-4  bg-neutral-950 placeholder:text-neutral-700"
                //  className="bg-muted text-md md:text-sm h-8 w-full bg-background shadow-none focus-visible:ring-2 focus-visible:ring-sidebar-ring"
                ref={inputRef} autoFocus placeholder="搜索..." 
              /> */}
              {/* <hr cmdk-raycast-loader="" /> */}
              <Command.List ref={listRef}>
                <Command.Empty>No results found.</Command.Empty>
                <Command.Group className="w-20 text-muted-foreground font-bold font-18 text-xxs mt-1" heading={navlinks[0].title}>
                  <div className="mt-1 flex flex-col gap-0">
                    {navlinks.map((link, idx) => (
                      <Item key={`LinkItem${idx}`} value={link.label} keywords={['issue', 'sprint']}
                        onSelect={()=>{ 
                          // llog('onSelect:' + link.href.slice(1) );
                          // setSpaceTag(link.href.slice(1));
                          debounceSelect(link.href);
                        }}
                        onMouseOver={()=>{
                          console.log('debouncedMoauseOver - MainSideBar1:',  link.href);
                          debouncedMoauseOver(link.href);
                        }} 
                      >
                        <SidebarLinkNoHref key={idx} link={link} />
                      </Item>
                    ))}
                  </div>
                </Command.Group>

                <Command.Group className="w-20 text-muted-foreground font-bold font-18 text-xxs mt-1" heading={medialinks[0].title}>
                  <div className="mt-1 flex flex-col gap-1">
                    {medialinks.map((link, idx) => (
                      <Item key={`LinkItem${idx}`} value={link.label} keywords={['issue', 'sprint']}
                        onSelect={()=>{ 
                          // llog('onSelect:' + link.href.slice(1) );
                          // setSpaceTag(link.href.slice(1));
                          debounceSelect(link.href);
                        }}
                        onMouseOver={()=>{
                          console.log('debouncedMoauseOver - MainSideBar2:',  link.href);
                          debouncedMoauseOver(link.href);
                        }} 
                      >
                        <SidebarLinkNoHref key={idx} link={link} />
                      </Item>
                    ))}
                  </div>
                </Command.Group>
                <Command.Group className="w-20 text-muted-foreground font-semibold font-14 text-xxs mt-4" heading={toollinks[0].title}>
                  <div className="mt-2 flex flex-col gap-2">
                    {toollinks.map((link, idx) => (
                      // eslint-disable-next-line react/jsx-key
                      <Item key={link.label} value={link.label} keywords={['issue', 'sprint']} 
                          onSelect={()=>{ 
                            // llog('onSelect:' + link.href.slice(1) );
                            // setSpaceTag(link.href.slice(1));
                            debounceSelect(link.href);
                          }} 
                          onMouseOver={()=>{  
                            console.log('debouncedMoauseOver - MainSideBar3:',  link.href);
                            debouncedMoauseOver(link.href) 
                          }} 
                        >
                          <SidebarLinkNoHref key={idx} link={link} />
                      </Item>
                    ))}
                  </div>
                </Command.Group>
              </Command.List>
            </Command>
            </CMDKWrapper>
        </div>
          {/* 底部贴底区域 (固定高度) */}
          {/* <div className="shrink-0 sticky bottom-0 z-10 bg-inherit  border-t mt-auto"> */}
          <div className="shrink-0 sticky bottom-0 z-10  bg-gray-100 dark:bg-neutral-800 border-t mt-auto">
            {/* 中间内容 */}
            {/* <div className="flex-1 overflow-y-auto overflow-x-hidden">
              <div className="mt-8 flex flex-col gap-2">
                {settingslinks.map((link, idx) => (
                  <SidebarLink key={idx} link={link} />
                ))}
              </div>
            </div> */}

            <SidebarLink
              link={{
                label: "LargeX",
                href: "#",
                icon: (
                  <Image
                    // src="https://assets.aceternity.com/sun.png"
                     src="/images/sun.png"
                    className="h-7 w-7 shrink-0 rounded-full"
                    width={50}
                    height={50}
                    alt="Avatar"
                  />
                ),
              }}
            />
          </div>
        </div>
      </SidebarBody>
    </Sidebar>
  );
}


export const Logo = () => {
  return (
    <Link
      href="#"
      className="font-normal flex space-x-2 items-center text-sm text-black py-1 relative z-20"
    >
      <div className="h-5 w-6 bg-black dark:bg-white rounded-br-lg rounded-tr-sm rounded-tl-lg rounded-bl-sm shrink-0" />
      <motion.span
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        className="font-medium text-black dark:text-white whitespace-pre"
      >
        AIGex
      </motion.span>
    </Link>
  );
};

export const LogoIcon = () => {
  return (
    <Link
      href="#"
      className="font-normal flex space-x-2 items-center text-sm text-black py-1 relative z-20"
    >
      <div className="h-5 w-6 bg-black dark:bg-white rounded-br-lg rounded-tr-sm rounded-tl-lg rounded-bl-sm shrink-0" />
    </Link>
  );
};
